import { SimplePage } from "@/app/_/marketing/SimplePage";
import { MultiEntityFeature } from "@/app/_/sections/3FeaturesSection/MultiEntityFeature";
import { Navigation } from "@/constants";

export default function Page() {
  return (
    <SimplePage
      eyebrow="Multi-entity"
      title="One workspace. Every entity."
      subtitle="Manage a portfolio of companies — or separate business and personal books — from a single platform. Transfer transactions between entities, reconcile intercompany balances, and switch context without losing your place."
      secondaryCta={{
        label: "Talk to us",
        to: "/company/contact",
      }}
      screenshot={{
        imageName: "multi-entity",
        alt: "Switching between four entities in one workspace",
      }}
      capabilities={[
        {
          title: "Switch without switching tools.",
          description:
            "Pick one entity or all of them. Every view — triage, reports, the ledger — follows the selection.",
          imageName: "crop-entity-switcher",
        },
        {
          title: "Every company in one queue.",
          description:
            "Review activity across entities side by side, each row labelled with the company and account it belongs to.",
          imageName: "crop-triage-list",
        },
        {
          title: "Consolidated, or one at a time.",
          description:
            "The same dashboard reports on a single entity or rolls them all up, with cash flow broken out per company.",
          imageName: "crop-report-widgets",
        },
      ]}
      illustration={{
        title: "Accounts wired to the right books.",
        description:
          "Bank and processor accounts feed the entity they belong to, and intercompany movements land on both sides.",
        render: () => MultiEntityFeature().center.renderChildren(),
      }}
      bullets={Navigation.PLATFORM_ITEMS.filter((item) =>
        ["/platform/reports", "/platform/agents"].includes(item.path),
      ).map((item) => ({
        ReactIcon: item.ReactIcon,
        name: item.name,
        tagline: item.tagline,
        to: item.path,
      }))}
    />
  );
}
